//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import myBottom from '@/components/myBottom/bottom.vue'
export default {
  name: 'reportlist',
  components: {
    'myBottom': myBottom
  },
  data () {
    return {
      list: [],
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      var params = new URLSearchParams()
      params.append('rows', 300)
      params.append('id', this.getCookie('schoolid'))
      this.$http({
        method: 'post',
        url: '/school/report/list',
        params: params
      }).then(res => {
        if (+res.code === 100) {
          this.list = res.result.list || []
          this.total = res.result.total || 0
        } else {
          this.$vux.toast.text(res.result.msg || res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    todetail (id) {
      this.$router.push({ path: '/dataReport', query: { id: id } })
    },
    downLoadPdf (id) {
      this.$router.push({ path: '/dataReport', query: { id: id, type: 'download' } })
    }
  },
  filters: {
    dateFormat (val) {
      let str = val
      if (str && str.length > 0) {
        str.replace('-', ' 年 ')
        str = str + ' 月'
        return str
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reportList/reportList.vue